import styled from 'styled-components';
import { FlexColumn } from '../../../styled/common';
import { Typography } from '../Typography';

export const ErrorContainer = styled(FlexColumn)`
  margin: 25px 15px 30px;
  align-items: center;
  justify-content: center;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    flex-direction: row-reverse;
    padding-right: 68px;
    gap: 150px;
    margin: 100px 40px;
  }

  @media (min-width: ${({ theme }) => theme.desktopBreakpoint}) {
    margin: 100px 20px;
  }
`;

export const MessageContainer = styled(FlexColumn)`
  align-items: center;

  > span {
    text-align: center;
  }

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    align-items: flex-start;

    > span {
      text-align: start;
    }
  }
`;

export const Title = styled(Typography)`
  margin-top: 30px;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    margin-top: 0;
    font-size: 22px;
  }
`;

export const Message = styled(Typography)`
  font-size: 16px;
  color: ${({ theme: { colors } }) => colors.text.secondary};
  margin-top: 15px;
  max-width: 424px;
`;

export const ButtonContainer = styled.div`
  margin-top: 30px;

  button {
    font-size: 16px;
    padding: 10px 60px;
    height: 48px;
    width: max-content;
  }
`;
